import {SpringConfig} from "react-spring";
import {IParticlesParams} from "react-particles-js";

export const springConfig: SpringConfig = {
	friction: 25,
	tension: 90
}

export const particleConfig: IParticlesParams = {
	background: {
		color: "#2E3440"
	},
	fpsLimit: 60,
	particles: {
		number: {
			value: 30,
			density: {
				enable: true,
				value_area: 1000
			}
		},
		color: {
			value: '#ffffff'
		},
		shape: {
			type: 'circle',
		},
		opacity: {
			value: 0.9,
			random: true,
		},
		size: {
			value: 3,
			random: true,
		},
		line_linked: {
			enable: true,
			distance: 250,
			color: '#ffffff',
			opacity: 0.2,
			width: 0.5
		},
		move: {
			enable: true,
			speed: 2,
			direction: 'none',
			random: true,
			out_mode: 'out',
		}
	},
	// interactivity: {
	// 	detect_on: 'canvas',
	// 	events: {
	// 		onHover: {
	// 			enable: true,
	// 			mode: 'grab'
	// 		},
	// 		onClick: {
	// 			enable: true,
	// 			mode: 'push'
	// 		},
	// 		resize: true
	// 	},
	// 	modes: {
	// 		grab: {
	// 			distance: 300,
	// 			line_linked: {
	// 				opacity: 0.4
	// 			}
	// 		},
	// 		push: {
	// 			particles_nb: 2
	// 		},
	// 	}
	// },
	retina_detect: true
}